export default "__VITE_ASSET__D2U5Q9rg__"